export const SUPPORT_PAGE = '/support';
export const IDV_PAGE = '/new/verify-id';
export const NBN_PAGE = '/go/internet';
